// Request all required permissions on app startup (Capacitor app AND web).
export async function requestAppPermissions() {
    const isCapacitor = !!(window as any).Capacitor;

    if (isCapacitor) {
        // Request notification permission (Android 13+)
        if ('Notification' in window && Notification.permission === 'default') {
            await Notification.requestPermission();
        }
        // Request location permission via Geolocation API
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                () => {}, // Success - permission granted
                () => {}, // Error - permission denied (user choice)
                { enableHighAccuracy: true, timeout: 5000 }
            );
        }
        return;
    }

    // ── Web / desktop browser ──
    // Browsers only show the notification permission prompt in response to a
    // user gesture, so ask on the first click/tap (once) if not yet decided.
    // Without this the web app never gets 'granted' and desktop notifications
    // silently never appear.
    if ('Notification' in window && Notification.permission === 'default') {
        const ask = () => {
            try { Notification.requestPermission().catch(() => {}); } catch { /* Safari <16 returns void */ }
            window.removeEventListener('click', ask);
            window.removeEventListener('keydown', ask);
            window.removeEventListener('touchstart', ask);
        };
        window.addEventListener('click', ask, { once: true });
        window.addEventListener('keydown', ask, { once: true });
        window.addEventListener('touchstart', ask, { once: true });
    }
}

/** Explicitly (re)request desktop-notification permission from a user click —
 *  used by the "Enable desktop alerts" control in the notification menu. */
export async function enableDesktopNotifications(): Promise<NotificationPermission | 'unsupported'> {
    if (!('Notification' in window)) return 'unsupported';
    if (Notification.permission === 'granted') return 'granted';
    try {
        const res = await Notification.requestPermission();
        return res;
    } catch {
        return Notification.permission;
    }
}
